(function () {
  const script = document.currentScript;
  const scriptOrigin = script?.src ? new URL(script.src).origin : window.location.origin;
  const apiBase = (script?.dataset.apiBase || scriptOrigin).replace(/\/$/, "");
  const title = script?.dataset.title || "Sam's AI";
  const locale = script?.dataset.locale || "auto";
  const storageKey = "sams-chatbot-session-id";
  const requestTimeoutMs = 30000;
  const oldWidgetSelector = [
    "#samnail-ai-button",
    "#samnail-ai-login-panel",
    "#samnail-ai-panel",
    "#samnail-ai-messages",
    "#samnail-ai-input",
    "#samnail-ai-send",
    "[id^='samnail-ai-']",
    "[class^='samnail-ai-']",
    "[class*=' samnail-ai-']"
  ].join(",");

  function removeOldSamNailAI() {
    document.querySelectorAll(oldWidgetSelector).forEach((node) => node.remove());
  }

  removeOldSamNailAI();
  document.addEventListener("DOMContentLoaded", removeOldSamNailAI);
  window.addEventListener("load", removeOldSamNailAI);

  if (document.documentElement) {
    const oldWidgetObserver = new MutationObserver(removeOldSamNailAI);
    oldWidgetObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.getElementById("sams-chatbot-widget")?.remove();

  const root = document.createElement("div");
  root.id = "sams-chatbot-widget";
  root.dataset.version = "1.2.0";
  root.innerHTML = `
    <button
      class="sams-chatbot-launch"
      type="button"
      aria-label="Open ${escapeHtml(title)}"
      aria-controls="sams-chatbot-panel"
      aria-expanded="false"
    >
      <span aria-hidden="true">S</span>
      <span class="sams-chatbot-launch-badge" aria-hidden="true">AI</span>
    </button>
    <section
      id="sams-chatbot-panel"
      class="sams-chatbot-panel"
      role="dialog"
      aria-labelledby="sams-chatbot-title"
      aria-busy="false"
      hidden
    >
      <header class="sams-chatbot-header">
        <div class="sams-chatbot-identity">
          <span class="sams-chatbot-mark" aria-hidden="true">S</span>
          <span>
            <strong id="sams-chatbot-title">${escapeHtml(title)}</strong>
            <small>Shopify catalog assistant</small>
          </span>
        </div>
        <div class="sams-chatbot-header-actions">
          <button class="sams-chatbot-new" type="button" aria-label="Start a new chat" title="New chat">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 5v14M5 12h14"></path>
            </svg>
          </button>
          <button class="sams-chatbot-close" type="button" aria-label="Close ${escapeHtml(title)}">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="m6 6 12 12M18 6 6 18"></path>
            </svg>
          </button>
        </div>
      </header>
      <div class="sams-chatbot-messages" aria-live="polite" aria-relevant="additions text"></div>
      <div class="sams-chatbot-compose">
        <form class="sams-chatbot-form">
          <label class="sams-chatbot-sr-only" for="sams-chatbot-input">Ask Sam's AI</label>
          <input
            id="sams-chatbot-input"
            name="message"
            autocomplete="off"
            maxlength="500"
            placeholder="Ask about products, prices, inventory..."
          />
          <button type="submit" aria-label="Send message">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="m4 4 17 8-17 8 3-8-3-8Zm3 8h14"></path>
            </svg>
            <span>Send</span>
          </button>
        </form>
        <p>Prices and stock can change before checkout.</p>
      </div>
    </section>
  `;

  const style = document.createElement("style");
  style.id = "sams-chatbot-widget-styles-v110";
  style.textContent = `
    #sams-chatbot-widget {
      --sams-green: #087f5b;
      --sams-green-dark: #066246;
      --sams-ink: #14211e;
      --sams-muted: #64716d;
      --sams-border: #dbe4e1;
      --sams-surface: #ffffff;
      --sams-soft: #f4f8f6;
      position: fixed;
      right: 18px;
      top: 50%;
      bottom: auto;
      z-index: 2147483000;
      transform: translateY(-50%);
      color: var(--sams-ink);
      font-family: Arial, Helvetica, sans-serif;
      font-size: 14px;
      line-height: 1.4;
    }
    #sams-chatbot-widget *,
    #sams-chatbot-widget *::before,
    #sams-chatbot-widget *::after {
      box-sizing: border-box;
    }
    #sams-chatbot-widget [hidden] {
      display: none !important;
    }
    .sams-chatbot-sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }
    .sams-chatbot-launch {
      position: relative;
      width: 60px;
      height: 60px;
      display: grid;
      place-items: center;
      border: 2px solid rgba(255, 255, 255, 0.9);
      border-radius: 50%;
      background: var(--sams-green);
      color: #fff;
      box-shadow: 0 14px 34px rgba(15, 23, 42, 0.26);
      cursor: pointer;
      font: inherit;
      font-size: 22px;
      font-weight: 800;
      transition: transform 160ms ease, background 160ms ease;
    }
    .sams-chatbot-launch:hover {
      transform: translateY(-2px);
      background: var(--sams-green-dark);
    }
    .sams-chatbot-launch-badge {
      position: absolute;
      right: -2px;
      bottom: -2px;
      min-width: 24px;
      height: 20px;
      display: grid;
      place-items: center;
      padding: 0 5px;
      border: 2px solid #fff;
      border-radius: 10px;
      background: var(--sams-ink);
      color: #fff;
      font-size: 9px;
      letter-spacing: 0.04em;
    }
    .sams-chatbot-panel {
      width: min(430px, calc(100vw - 28px));
      height: min(620px, calc(100vh - 32px));
      display: flex;
      flex-direction: column;
      overflow: hidden;
      border: 1px solid var(--sams-border);
      border-radius: 14px;
      background: var(--sams-surface);
      box-shadow: 0 22px 60px rgba(15, 23, 42, 0.24);
    }
    .sams-chatbot-header {
      min-height: 66px;
      display: flex;
      flex: 0 0 auto;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 10px 12px;
      border-bottom: 1px solid var(--sams-border);
      background: #f8faf9;
    }
    .sams-chatbot-identity {
      min-width: 0;
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .sams-chatbot-mark {
      width: 38px;
      height: 38px;
      display: grid;
      flex: 0 0 auto;
      place-items: center;
      border-radius: 11px;
      background: var(--sams-green);
      color: #fff;
      font-size: 18px;
      font-weight: 800;
    }
    .sams-chatbot-identity strong,
    .sams-chatbot-identity small {
      display: block;
    }
    .sams-chatbot-identity strong {
      overflow: hidden;
      color: var(--sams-ink);
      font-size: 15px;
      line-height: 1.25;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .sams-chatbot-identity small {
      margin-top: 2px;
      color: var(--sams-muted);
      font-size: 11px;
    }
    .sams-chatbot-header-actions {
      display: flex;
      gap: 2px;
    }
    .sams-chatbot-header-actions button {
      width: 34px;
      height: 34px;
      display: grid;
      place-items: center;
      border: 0;
      border-radius: 50%;
      background: transparent;
      color: #41504c;
      cursor: pointer;
    }
    .sams-chatbot-header-actions button:hover {
      background: #eaf1ee;
      color: var(--sams-green-dark);
    }
    .sams-chatbot-header-actions svg,
    .sams-chatbot-form svg {
      width: 18px;
      height: 18px;
      fill: none;
      stroke: currentColor;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 2;
    }
    .sams-chatbot-messages {
      min-height: 0;
      flex: 1 1 auto;
      overflow-y: auto;
      overscroll-behavior: contain;
      padding: 16px;
      background: #fbfcfc;
      scrollbar-color: #c4d0cc transparent;
      scrollbar-width: thin;
    }
    .sams-chatbot-message {
      max-width: 88%;
      margin: 0 0 12px;
      padding: 10px 12px;
      border-radius: 12px;
      line-height: 1.45;
      white-space: pre-wrap;
      overflow-wrap: anywhere;
    }
    .sams-chatbot-message.user {
      margin-left: auto;
      border-bottom-right-radius: 4px;
      background: var(--sams-green);
      color: #fff;
    }
    .sams-chatbot-message.assistant {
      border-bottom-left-radius: 4px;
      background: #edf3f1;
      color: var(--sams-ink);
    }
    .sams-chatbot-order-action {
      min-height: 34px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-top: 9px;
      border-radius: 7px;
      padding: 0 12px;
      background: var(--sams-ink);
      color: #fff;
      font-size: 12px;
      font-weight: 800;
      text-decoration: none;
    }
    .sams-chatbot-order-action:hover {
      background: var(--sams-green-dark);
    }
    .sams-chatbot-message.assistant.has-products,
    .sams-chatbot-message.assistant.welcome {
      width: 100%;
      max-width: 100%;
      padding: 0;
      background: transparent;
      white-space: normal;
    }
    .sams-chatbot-welcome-card {
      padding: 14px;
      border: 1px solid var(--sams-border);
      border-radius: 12px;
      background: #fff;
      box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
    }
    .sams-chatbot-eyebrow {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      margin-bottom: 7px;
      color: var(--sams-green-dark);
      font-size: 11px;
      font-weight: 800;
      letter-spacing: 0.04em;
      text-transform: uppercase;
    }
    .sams-chatbot-eyebrow::before {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #22c55e;
      content: "";
      box-shadow: 0 0 0 3px #dcfce7;
    }
    .sams-chatbot-welcome-card p {
      margin: 0;
      color: #34423e;
      font-size: 14px;
      line-height: 1.5;
    }
    .sams-chatbot-quick-prompts {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 7px;
      margin-top: 12px;
    }
    .sams-chatbot-quick-prompt {
      min-height: 38px;
      padding: 7px 9px;
      border: 1px solid #cddbd6;
      border-radius: 9px;
      background: var(--sams-soft);
      color: #24463b;
      cursor: pointer;
      font: inherit;
      font-size: 11px;
      font-weight: 700;
      line-height: 1.25;
      text-align: left;
    }
    .sams-chatbot-quick-prompt:hover {
      border-color: #87b4a4;
      background: #e6f4ee;
    }
    .sams-chatbot-response-text {
      display: inline-block;
      max-width: 88%;
      margin-bottom: 10px;
      padding: 10px 12px;
      border-radius: 12px 12px 12px 4px;
      background: #edf3f1;
      line-height: 1.45;
      white-space: pre-wrap;
      overflow-wrap: anywhere;
    }
    .sams-chatbot-products {
      display: grid;
      gap: 10px;
    }
    .sams-chatbot-product-card {
      display: grid;
      grid-template-columns: 82px minmax(0, 1fr);
      gap: 12px;
      padding: 10px;
      border: 1px solid var(--sams-border);
      border-radius: 12px;
      background: #fff;
      box-shadow: 0 7px 20px rgba(15, 23, 42, 0.07);
    }
    .sams-chatbot-product-image,
    .sams-chatbot-product-placeholder {
      width: 82px;
      height: 82px;
      border-radius: 9px;
      background: #f0f4f3;
    }
    .sams-chatbot-product-image {
      display: block;
      object-fit: cover;
    }
    .sams-chatbot-product-placeholder {
      display: grid;
      place-items: center;
      color: var(--sams-muted);
      font-size: 12px;
      font-weight: 800;
    }
    .sams-chatbot-product-body {
      min-width: 0;
      display: grid;
      align-content: start;
      gap: 5px;
    }
    .sams-chatbot-product-title {
      display: -webkit-box;
      overflow: hidden;
      color: var(--sams-ink);
      font-size: 13px;
      font-weight: 800;
      line-height: 1.3;
      text-decoration: none;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .sams-chatbot-product-title:hover {
      color: var(--sams-green-dark);
      text-decoration: underline;
    }
    .sams-chatbot-product-meta,
    .sams-chatbot-product-inventory {
      overflow: hidden;
      color: var(--sams-muted);
      font-size: 11px;
      line-height: 1.3;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .sams-chatbot-product-inventory.out {
      color: #b42318;
      font-weight: 700;
    }
    .sams-chatbot-product-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      margin-top: 2px;
    }
    .sams-chatbot-product-price {
      color: var(--sams-green-dark);
      font-size: 14px;
      font-weight: 800;
      white-space: nowrap;
    }
    .sams-chatbot-product-action {
      min-height: 32px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 7px;
      padding: 0 11px;
      background: var(--sams-ink);
      color: #fff;
      font-size: 11px;
      font-weight: 800;
      text-decoration: none;
      white-space: nowrap;
    }
    .sams-chatbot-product-action:hover {
      background: var(--sams-green-dark);
    }
    .sams-chatbot-loading {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      color: #4e5d58;
    }
    .sams-chatbot-loading-dots {
      display: inline-flex;
      gap: 3px;
    }
    .sams-chatbot-loading-dots i {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: var(--sams-green);
      animation: sams-chatbot-pulse 1s infinite ease-in-out;
    }
    .sams-chatbot-loading-dots i:nth-child(2) {
      animation-delay: 120ms;
    }
    .sams-chatbot-loading-dots i:nth-child(3) {
      animation-delay: 240ms;
    }
    .sams-chatbot-compose {
      flex: 0 0 auto;
      padding: 10px 10px 8px;
      border-top: 1px solid var(--sams-border);
      background: #fff;
    }
    .sams-chatbot-form {
      display: flex;
      gap: 8px;
      align-items: center;
    }
    .sams-chatbot-form input {
      min-width: 0;
      height: 42px;
      flex: 1;
      border: 1px solid #cbd7d3;
      border-radius: 8px;
      padding: 0 11px;
      background: #fff;
      color: var(--sams-ink);
      font: inherit;
      font-size: 13px;
      outline: none;
    }
    .sams-chatbot-form input:focus {
      border-color: var(--sams-green);
      box-shadow: 0 0 0 3px rgba(8, 127, 91, 0.13);
    }
    .sams-chatbot-form button {
      height: 42px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      border: 0;
      border-radius: 8px;
      padding: 0 14px;
      background: var(--sams-ink);
      color: #fff;
      cursor: pointer;
      font: inherit;
      font-size: 12px;
      font-weight: 800;
    }
    .sams-chatbot-form button:hover {
      background: var(--sams-green-dark);
    }
    .sams-chatbot-form input:disabled,
    .sams-chatbot-form button:disabled {
      cursor: wait;
      opacity: 0.62;
    }
    .sams-chatbot-compose > p {
      margin: 6px 2px 0;
      color: #7b8783;
      font-size: 9px;
      line-height: 1.25;
      text-align: center;
    }
    #sams-chatbot-widget button:focus-visible,
    #sams-chatbot-widget a:focus-visible,
    #sams-chatbot-widget input:focus-visible {
      outline: 3px solid rgba(8, 127, 91, 0.28);
      outline-offset: 2px;
    }
    @keyframes sams-chatbot-pulse {
      0%, 80%, 100% { opacity: 0.35; transform: translateY(0); }
      40% { opacity: 1; transform: translateY(-2px); }
    }
    @media (max-width: 640px) {
      #sams-chatbot-widget {
        right: 14px;
        top: auto;
        bottom: 14px;
        transform: none;
      }
      .sams-chatbot-panel {
        position: fixed;
        inset: 8px;
        width: auto;
        height: auto;
        max-width: none;
        max-height: none;
        border-radius: 13px;
      }
      .sams-chatbot-product-card {
        grid-template-columns: 72px minmax(0, 1fr);
      }
      .sams-chatbot-product-image,
      .sams-chatbot-product-placeholder {
        width: 72px;
        height: 72px;
      }
    }
    @media (max-width: 370px) {
      .sams-chatbot-quick-prompts {
        grid-template-columns: 1fr;
      }
      .sams-chatbot-form button span {
        display: none;
      }
      .sams-chatbot-form button {
        width: 44px;
        padding: 0;
      }
    }
    @media (prefers-reduced-motion: reduce) {
      .sams-chatbot-launch,
      .sams-chatbot-loading-dots i {
        transition: none;
        animation: none;
      }
    }
  `;

  document.head.appendChild(style);
  document.body.appendChild(root);

  const managedWidgetObserver = new MutationObserver(() => {
    const currentRoot = document.getElementById("sams-chatbot-widget");
    if (currentRoot === root) return;
    currentRoot?.remove();
    if (!root.isConnected) document.body.appendChild(root);
    document.head.appendChild(style);
  });
  managedWidgetObserver.observe(document.documentElement, { childList: true, subtree: true });

  const launch = root.querySelector(".sams-chatbot-launch");
  const panel = root.querySelector(".sams-chatbot-panel");
  const close = root.querySelector(".sams-chatbot-close");
  const newChat = root.querySelector(".sams-chatbot-new");
  const messages = root.querySelector(".sams-chatbot-messages");
  const form = root.querySelector(".sams-chatbot-form");
  const input = form.querySelector("input");
  const submit = form.querySelector("button[type='submit']");
  let isBusy = false;

  launch.addEventListener("click", openPanel);
  close.addEventListener("click", closePanel);
  newChat.addEventListener("click", resetConversation);
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    sendMessage(input.value);
  });
  messages.addEventListener("click", (event) => {
    const button = event.target.closest(".sams-chatbot-quick-prompt");
    if (!button) return;
    const prompt = button.dataset.prompt || "";
    if (button.dataset.action === "fill") {
      input.value = prompt;
      input.focus();
      input.setSelectionRange(input.value.length, input.value.length);
      return;
    }
    sendMessage(prompt);
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !panel.hidden) closePanel();
  });

  function openPanel() {
    panel.hidden = false;
    launch.hidden = true;
    launch.setAttribute("aria-expanded", "true");
    if (!messages.childElementCount) renderWelcome();
    input.focus();
  }

  function closePanel() {
    panel.hidden = true;
    launch.hidden = false;
    launch.setAttribute("aria-expanded", "false");
    launch.focus();
  }

  function resetConversation() {
    if (isBusy) return;
    safeStorageRemove(storageKey);
    messages.textContent = "";
    renderWelcome();
    input.value = "";
    input.focus();
  }

  function renderWelcome() {
    const wrapper = document.createElement("div");
    wrapper.className = "sams-chatbot-message assistant welcome";
    wrapper.innerHTML = `
      <div class="sams-chatbot-welcome-card">
        <span class="sams-chatbot-eyebrow">Store knowledge connected</span>
        <p>Hi! I can help with products, prices, store stock, shipping, order tracking, and returns. What do you need?</p>
        <div class="sams-chatbot-quick-prompts" aria-label="Suggested questions">
          <button class="sams-chatbot-quick-prompt" type="button" data-prompt="Recommend gel polish">Recommend gel polish</button>
          <button class="sams-chatbot-quick-prompt" type="button" data-prompt="Do you have OPI Bubble Bath?">Check OPI Bubble Bath</button>
          <button class="sams-chatbot-quick-prompt" type="button" data-prompt="Compare top coats">Compare top coats</button>
          <button class="sams-chatbot-quick-prompt" type="button" data-action="fill" data-prompt="Find SKU ">Search by SKU</button>
          <button class="sams-chatbot-quick-prompt" type="button" data-prompt="Why did I not get free shipping?">Shipping &amp; free shipping</button>
          <button class="sams-chatbot-quick-prompt" type="button" data-prompt="I need help with a return or damaged order">Returns or damaged order</button>
        </div>
      </div>
    `;
    messages.appendChild(wrapper);
  }

  async function sendMessage(rawMessage) {
    const message = String(rawMessage || "").trim();
    if (!message || isBusy) return;

    input.value = "";
    addMessage("user", message);
    const pending = addLoadingMessage();
    setBusy(true);

    if (isOrderTrackingRequest(message)) {
      renderOrderTrackingResult(pending);
      setBusy(false);
      scrollToLatest();
      input.focus();
      return;
    }

    try {
      const response = await requestChat({
        sessionId: safeStorageGet(storageKey),
        locale,
        message
      });
      const json = response.json;
      if (!response.ok || !json.ok) throw new Error(json.error || "Chat request failed.");

      safeStorageSet(storageKey, json.sessionId);
      renderAssistantResult(pending, json.reply || "I could not find an answer yet.", json.products || []);
    } catch (error) {
      pending.className = "sams-chatbot-message assistant";
      pending.textContent =
        error?.name === "AbortError"
          ? "The catalog search took too long. Please try a shorter product name or SKU."
          : "I could not reach Sam's AI right now. Please try again in a moment.";
      console.error("Sam's AI request failed.", error);
    } finally {
      setBusy(false);
      scrollToLatest();
      input.focus();
    }
  }

  function requestChat(payload) {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open("POST", `${apiBase}/api/chat`, true);
      request.setRequestHeader("Content-Type", "application/json");
      request.timeout = requestTimeoutMs;

      request.addEventListener("load", () => {
        let json = {};
        try {
          json = JSON.parse(request.responseText || "{}");
        } catch {
          // The caller will surface the standard chat error for invalid JSON.
        }
        resolve({
          ok: request.status >= 200 && request.status < 300,
          json
        });
      });
      request.addEventListener("error", () => reject(new TypeError("Chat request failed.")));
      request.addEventListener("timeout", () => reject(createRequestError("AbortError", "Chat request timed out.")));
      request.addEventListener("abort", () => reject(createRequestError("AbortError", "Chat request was aborted.")));
      request.send(JSON.stringify(payload));
    });
  }

  function createRequestError(name, message) {
    const error = new Error(message);
    error.name = name;
    return error;
  }

  function isOrderTrackingRequest(message) {
    return /\b(?:track|where(?:'s| is)?|status|locate|find)\b[^\n]{0,28}\b(?:my\s+)?order\b|\b(?:my\s+)?order\b[^\n]{0,28}\b(?:track|status|where|locate|find)\b/i.test(message);
  }

  function renderOrderTrackingResult(element) {
    element.className = "sams-chatbot-message assistant";
    element.textContent = "Sign in to view your order history and status. If the order has shipped, the shipping confirmation email also includes its carrier tracking link.";

    const action = document.createElement("a");
    action.className = "sams-chatbot-order-action";
    action.href = "/account";
    action.target = "_top";
    action.textContent = "View my orders";
    element.appendChild(document.createElement("br"));
    element.appendChild(action);
  }

  function setBusy(busy) {
    isBusy = busy;
    panel.setAttribute("aria-busy", String(busy));
    input.disabled = busy;
    submit.disabled = busy;
  }

  function addMessage(role, text) {
    const element = document.createElement("div");
    element.className = `sams-chatbot-message ${role}`;
    element.textContent = text;
    messages.appendChild(element);
    scrollToLatest();
    return element;
  }

  function addLoadingMessage() {
    const element = document.createElement("div");
    element.className = "sams-chatbot-message assistant";
    element.innerHTML = `
      <span class="sams-chatbot-loading">
        <span class="sams-chatbot-loading-dots" aria-hidden="true"><i></i><i></i><i></i></span>
        Checking Sam's knowledge…
      </span>
    `;
    messages.appendChild(element);
    scrollToLatest();
    return element;
  }

  function renderAssistantResult(element, reply, products) {
    const items = (Array.isArray(products) ? products : []).slice(0, 3);
    if (!items.length) {
      element.className = "sams-chatbot-message assistant";
      element.textContent = reply;
      return;
    }

    element.className = "sams-chatbot-message assistant has-products";
    element.textContent = "";

    const intro = document.createElement("div");
    intro.className = "sams-chatbot-response-text";
    intro.textContent = cleanReplyForCards(reply);
    element.appendChild(intro);

    const list = document.createElement("div");
    list.className = "sams-chatbot-products";
    items.forEach((product) => list.appendChild(createProductCard(product)));
    element.appendChild(list);
  }

  function createProductCard(product) {
    const variant = selectDisplayVariant(product);
    const imageUrl = variant.imageUrl || product.imageUrl;
    const productUrl = product.productUrl || product.product_url || "";
    const knownInventory = hasKnownInventory(variant);
    const inStock = hasAvailableInventory(variant);
    const canAddToCart = Boolean(variant.addToCartUrl) && (inStock || !knownInventory);
    const actionUrl = canAddToCart ? variant.addToCartUrl : productUrl || variant.addToCartUrl;

    const card = document.createElement("article");
    card.className = "sams-chatbot-product-card";

    if (imageUrl) {
      const image = document.createElement("img");
      image.className = "sams-chatbot-product-image";
      image.src = imageUrl;
      image.alt = product.title ? `${product.title} product image` : "Product image";
      image.loading = "lazy";
      image.addEventListener("error", () => image.replaceWith(createImagePlaceholder()));
      card.appendChild(image);
    } else {
      card.appendChild(createImagePlaceholder());
    }

    const body = document.createElement("div");
    body.className = "sams-chatbot-product-body";

    const titleLink = document.createElement(productUrl ? "a" : "div");
    titleLink.className = "sams-chatbot-product-title";
    titleLink.textContent = product.title || "Product";
    if (productUrl) {
      titleLink.href = productUrl;
      titleLink.target = "_top";
    }
    body.appendChild(titleLink);

    const meta = document.createElement("div");
    meta.className = "sams-chatbot-product-meta";
    meta.textContent = buildMetaLine(product, variant);
    body.appendChild(meta);

    const inventory = document.createElement("div");
    inventory.className = `sams-chatbot-product-inventory${knownInventory && !inStock ? " out" : ""}`;
    inventory.textContent = buildInventoryLine(product, variant);
    body.appendChild(inventory);

    const footer = document.createElement("div");
    footer.className = "sams-chatbot-product-footer";

    const price = document.createElement("span");
    price.className = "sams-chatbot-product-price";
    price.textContent = formatMoney(variant.price);
    footer.appendChild(price);

    if (actionUrl) {
      const action = document.createElement("a");
      action.className = "sams-chatbot-product-action";
      action.href = actionUrl;
      action.target = "_top";
      action.textContent = canAddToCart ? "Add to cart" : "View product";
      footer.appendChild(action);
    }

    body.appendChild(footer);
    card.appendChild(body);
    return card;
  }

  function createImagePlaceholder() {
    const placeholder = document.createElement("div");
    placeholder.className = "sams-chatbot-product-placeholder";
    placeholder.textContent = "Sam's";
    return placeholder;
  }

  function selectDisplayVariant(product) {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    return variants[0] || {};
  }

  function buildMetaLine(product, variant) {
    const pieces = [
      product.vendor,
      variant.title && variant.title !== "Default Title" ? variant.title : "",
      variant.sku ? `SKU ${variant.sku}` : ""
    ].filter(Boolean);
    return pieces.join(" · ") || product.productType || "Product match";
  }

  function buildInventoryLine(product, variant) {
    const locations = Array.isArray(variant.inventoryByLocation) ? variant.inventoryByLocation : [];
    const knownLocations = locations.filter((location) => location.available !== null && location.available !== undefined);
    const availableLocations = knownLocations.filter((location) => Number(location.available) > 0);
    const locationText = availableLocations
      .slice(0, 2)
      .map((location) => `${location.locationName}: ${location.available}`)
      .join(", ");

    if (locationText) {
      const extra = availableLocations.length > 2 ? ` +${availableLocations.length - 2} more` : "";
      return `In stock · ${locationText}${extra}`;
    }
    if (variant.inventoryQuantity !== null && variant.inventoryQuantity !== undefined) {
      const quantity = Number(variant.inventoryQuantity);
      return quantity > 0 ? `In stock · ${quantity} total` : "Out of stock";
    }
    if (knownLocations.length) return "Out of stock";
    if (product.totalInventory !== null && product.totalInventory !== undefined) {
      const total = Number(product.totalInventory);
      return total > 0 ? `In stock · ${total} total` : "Out of stock";
    }
    return "Stock: check product page";
  }

  function hasKnownInventory(variant) {
    if (variant.inventoryQuantity !== null && variant.inventoryQuantity !== undefined) return true;
    return (variant.inventoryByLocation || []).some(
      (location) => location.available !== null && location.available !== undefined
    );
  }

  function hasAvailableInventory(variant) {
    const locations = Array.isArray(variant.inventoryByLocation) ? variant.inventoryByLocation : [];
    if (locations.some((location) => Number(location.available) > 0)) return true;
    return Number(variant.inventoryQuantity) > 0;
  }

  function formatMoney(value) {
    const number = Number(value);
    if (!Number.isFinite(number)) return "Price unavailable";
    return `$${number.toFixed(2)}`;
  }

  function cleanReplyForCards(reply) {
    const text = String(reply || "").replace(/\*\*/g, "").trim();
    const usefulLines = text
      .split(/\n+/)
      .map((line) => line.trim())
      .filter(Boolean)
      .filter((line) => !/^(?:SKU|Price|Link|Add to cart|Product URL):/i.test(line));
    const usefulText = usefulLines.join("\n");
    const listIndex = usefulText.search(/\n\s*(?:\d+[\.)]|[-*])\s+/);
    const candidate = listIndex > 20 ? usefulText.slice(0, listIndex).trim() : usefulLines.slice(0, 2).join(" ");
    const compact = candidate.replace(/\s+/g, " ");

    if (compact.length <= 240) return compact || "Here are the best matches I found:";
    const sentences = compact.match(/[^.!?]+[.!?]+/g);
    if (sentences?.length) return sentences.slice(0, 2).join(" ").trim();
    return `${compact.slice(0, 237).trim()}...`;
  }

  function scrollToLatest() {
    messages.scrollTop = messages.scrollHeight;
  }

  function safeStorageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  function safeStorageSet(key, value) {
    if (!value) return;
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // Browsing can continue without persisted chat history.
    }
  }

  function safeStorageRemove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // Browsing can continue without persisted chat history.
    }
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (char) => {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      }[char];
    });
  }
})();
